import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=2f16e5ac"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=2f16e5ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports